/* ============================================================
   SINGSPACE ADMIN - ROUTE PROTÉGÉE
   ============================================================ */

import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="loading-screen">
        <img src="/logo-seul.png" alt="SingSpace" className="loading-logo" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
